import React, { useEffect, useState } from "react";
import "../styles/home.css";
import "../styles/table.css";
import "../styles/theme.css";
import Layout from "./Layout";
import { getTransactionData } from "../functions/api/transactions";
import TransactionTable from "./display/TableComponent";

const getYesterday = (): string => {
	const date = new Date();
	date.setDate(date.getDate() - 1);
	return date.toISOString().slice(0, 10); // YYYY-MM-DD
};

const TransactionsComponent: React.FC = () => {
	const [transactionData, setTransactionData] = useState<any[]>([]);
	const [selectedDate, setSelectedDate] = useState<string>(getYesterday());
	const [loading, setLoading] = useState<boolean>(true);

	const loadData = async (date: string) => {
		setLoading(true);
		const data = await getTransactionData(date);
		if (Array.isArray(data)) {
			setTransactionData(data);
		} else {
			setTransactionData([]);
		}
		setLoading(false);
	};

	useEffect(() => {
		loadData(selectedDate);
	}, []);

	const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newDate = e.target.value;
		setSelectedDate(newDate);
		loadData(newDate);
	};

	return (
		<Layout>
			<div className="home-container" style={{ overflowX: "auto" }}>
				<h2 className="home-header">Transactions</h2>

				{/* DATE selection */}
				<div style={{ marginBottom: "1rem" }}>
					<label style={{ marginRight: "0.5rem" }}>Date:</label>
					<div className="date-picker-wrapper">

				{/* Left Arrow Button */}
				<button className="date-arrow" onClick={() => {
						const prev = new Date(selectedDate);
						prev.setDate(prev.getDate() - 1);
						handleDateChange({
							target: { value: prev.toISOString().slice(0, 10) }
						} as React.ChangeEvent<HTMLInputElement>);
					}}
				>←
				</button>

					<input
						type="date"
						value={selectedDate}
						onChange={handleDateChange}
						style={{ padding: "0.4rem" }}
					/>

				{/* Right Arrow Button */}
				<button className="date-arrow" onClick={() => {
						const next = new Date(selectedDate);
						next.setDate(next.getDate() + 1);
						handleDateChange({
							target: { value: next.toISOString().slice(0, 10) }
						} as React.ChangeEvent<HTMLInputElement>);
					}}
				>→
				</button>
				</div>
				</div>

				{loading ? (
					<p>Loading...</p>
				) : transactionData.length > 0 ? (
					<div className="table-scroll-wrapper">
						<div className="table-scroll-inner">
							<TransactionTable data={transactionData} />
						</div>
					</div>
				) : (
					<p>No data found for {selectedDate}.</p>
				)}
			</div>
		</Layout>
	);
};

export default TransactionsComponent;
